import React, { createContext, useState, useContext, useEffect } from 'react';
import { supabase } from '../supabaseClient';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for authenticated user in localStorage
    const checkAuth = () => {
      const isAuthenticated = localStorage.getItem('memo_authenticated') === 'true';
      const userEmail = localStorage.getItem('memo_user_email');
      
      if (isAuthenticated && userEmail) {
        setUser({ email: userEmail });
      }
      
      setLoading(false);
    };
    
    checkAuth();
  }, []);

  // Login function
  const login = async (email, password) => {
    try {
      // Use RPC to call the secure credential checking function
      const { data, error } = await supabase.rpc('check_memo_credentials', {
        email_input: email,
        password_input: password
      });
      
      if (error) throw error;
      
      // data will be a boolean - true if credentials exist
      if (!data) {
        throw new Error('Invalid credentials');
      }
      
      // Store authentication in localStorage
      localStorage.setItem('memo_authenticated', 'true');
      localStorage.setItem('memo_user_email', email);
      
      // Update user state
      setUser({ email });
      
      return { success: true };
    } catch (error) {
      console.error("Login error:", error);
      return { success: false, error: error.message };
    }
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem('memo_authenticated');
    localStorage.removeItem('memo_user_email');
    setUser(null);
  };

  const value = {
    user,
    login,
    logout,
    isAuthenticated: !!user
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 